<!-- Caixa de Novo Comentário na Tab -->
<div class="tab-novo-comentario-card mb-4">
  <div class="novo-comentario-wrapper">
    <div class="user-avatar-circle">
      <span>{{ userInitials || 'U' }}</span>
    </div>
    <div class="novo-comentario-input-col">
      <textarea pTextarea [(ngModel)]="novoConteudoComentario"
        placeholder="Escreva a sua mensagem ou apoio a esta campanha..."
        rows="2" class="novo-comentario-textarea"
        (keydown)="onNovoComentarioEnter($event)"></textarea>
      <div class="novo-comentario-footer">
        <span class="key-hint">Pressione <kbd>Enter</kbd> para enviar</span>
        <button type="button" class="btn-enviar-comentario"
          [disabled]="isSubmittingNovo || !novoConteudoComentario?.trim()"
          (click)="submeterNovoComentario()">
          <i class="pi pi-spin pi-spinner" *ngIf="isSubmittingNovo"></i>
          <i class="pi pi-send" *ngIf="!isSubmittingNovo"></i>
          <span>Comentar</span>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="comments?.length; else noData">
  <form [formGroup]="formEditComment" class="comments-list-wrapper">
    <div class="comment_item" *ngFor="let commentCtrl of commentsArray.controls; let i = index"
      [formGroup]="commentCtrl">
      <div class="initial">
        <span>{{ getAuthorName(commentCtrl.value) | initials }}</span>
      </div>

      <div class="comment_body">
        <div class="comment_header">
          <div class="author-info">
            <h5 class="author-name">{{ getAuthorName(commentCtrl.value) }}</h5>
            <span class="badge-you" *ngIf="commentCtrl.value.utilizadorID === UserID">Você</span>
          </div>

          <div class="comment-actions" *ngIf="commentCtrl.value.utilizadorID === UserID">
            <p-menu #menu [model]="items" [popup]="true" appendTo="body">
              <ng-template pTemplate="item" let-item appendTo="body">
                <button type="button"
                  class="menu-action w-full text-left px-3 py-2 flex align-items-center gap-2"
                  (click)="item.label === 'Editar' ? enableEdit(commentCtrl, i) : deleteComment(commentCtrl.value.id)">
                  <i [class]="item.icon"></i>
                  <span>{{ item.label }}</span>
                </button>
              </ng-template>
            </p-menu>

            <button type="button" class="btn-options" (click)="menu.toggle($event)" title="Mais opções">
              <i class="pi pi-ellipsis-v"></i>
            </button>
          </div>
        </div>

        <!-- Modo Normal: Apresentação de informação, sem aspecto de campo de formulário/digitação -->
        <div class="comment-content" *ngIf="showComment !== i">
          <p class="comment-text">{{ commentCtrl.value.conteudo }}</p>
        </div>

        <!-- Modo de Edição -->
        <div class="comment-edit-box" *ngIf="showComment === i">
          <textarea pTextarea formControlName="conteudo" rows="2" class="comment-edit-textarea"
            placeholder="Edite o seu comentário..."></textarea>
          <div class="comment-edit-actions">
            <button type="button" class="btn-cancel-edit" (click)="cancelEdit()">
              Cancelar
            </button>
            <button type="button" class="btn-save-edit" (click)="submitComment(commentCtrl)">
              <i class="pi pi-check"></i>
              <span>Guardar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>

<ng-template #noData>
  <div class="nodata">
    <app-data-void titulo="Ainda sem comentários" descricao="Envie o seu comentário"></app-data-void>
  </div>
</ng-template>
<p-confirm-dialog></p-confirm-dialog>